/* eslint-disable */
import type {DocumentNode} from 'graphql';
import * as ApolloReactHooks from '@apollo/client/react';
import type {DeleteMapLabelMutation, DeleteMapLabelMutationVariables} from '../types';

export const DeleteMapLabelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteMapLabel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteMapLabel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode;
/** hook для мутации "DeleteMapLabel" */
export function useDeleteMapLabelMutation(
    baseOptions?: ApolloReactHooks.MutationHookOptions<
        DeleteMapLabelMutation,
        DeleteMapLabelMutationVariables        
    >,
) {
    return ApolloReactHooks.useMutation<
    DeleteMapLabelMutation,
    DeleteMapLabelMutationVariables
    >(DeleteMapLabelDocument, baseOptions ?? ({} as ApolloReactHooks.MutationHookOptions<DeleteMapLabelMutation, DeleteMapLabelMutationVariables>));
}
